var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9938 13.2499C14.0609 11.6428 12.5675 10.4365 10.8001 9.86244C11.6472 9.35867 12.3056 8.59069 12.674 7.67647C13.0423 6.76225 13.1004 5.75237 12.8391 4.80198C12.5779 3.85158 12.0119 3.01324 11.228 2.41574C10.4441 1.81824 9.4857 1.49463 8.50006 1.49463C7.51442 1.49463 6.55603 1.81824 5.77214 2.41574C4.98825 3.01324 4.42221 3.85158 4.16098 4.80198C3.89975 5.75237 3.95779 6.76225 4.32616 7.67647C4.69454 8.59069 5.35288 9.35867 6.20006 9.86244C4.43262 10.4365 2.93927 11.6428 2.00631 13.2499C1.9605 13.3253 1.93628 13.4118 1.93628 13.4999C1.93628 13.5881 1.9605 13.6746 2.00631 13.7499C2.04905 13.8266 2.11167 13.8902 2.18757 13.9342C2.26347 13.9782 2.34983 14.0009 2.43756 13.9999H14.5626C14.6503 14.0009 14.7367 13.9782 14.8126 13.9342C14.8885 13.8902 14.9511 13.8266 14.9938 13.7499C15.0396 13.6746 15.0638 13.5881 15.0638 13.4999C15.0638 13.4118 15.0396 13.3253 14.9938 13.2499V13.2499Z",
    fill: "#C6D101"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.0eaa2761c4fbc1dd1355ba4ace4ca982.svg";
export { ForwardRef as ReactComponent };